const FaqPage = (props) => {
  return `{
      "@context": "https://schema.org",
      "@type": "FAQPage",
      "mainEntity": [
      ${props.questions.map((question) => {
        return `
            {
              "@type": "Question",
              "url":"${question.url}",
              "name": "${question.name}",
              "acceptedAnswer": {
                "@type": "Answer",
                "text": "${question.acceptedAnswer.answer}"
              }
            }
            `;
      })}
      ]
    }`;
};

export default FaqPage;
